// 根据 canIPayOutOfKuaikan 不同进行不同操作
// 0: 端外任何点击都会唤起app
// 1: 可以在端外支付 其他点击行为和端内一致
// 端内正常执行点击事件
function isKuaikanApp() {
    var userAgent = navigator.userAgent.toLowerCase();
    return /kuaikan\//.test(userAgent);
}
export default {
    bind(el, binding, vnode) {
        let canIPayOutOfKuaikan = binding.arg || false;
        let defaultHandler = () => { };
        let clickHandler;

        if (isKuaikanApp()) {
            clickHandler = binding.value.callback || defaultHandler;
        } else {
            if (canIPayOutOfKuaikan) {
                clickHandler = binding.value.callback || defaultHandler;
            } else {
                let link = binding.value.link;
                clickHandler = () => {
                    link && (location.href = link);
                };
            }
        }
        el.addEventListener("click", (event) => {
            clickHandler();
            let {stop = false} = binding.modifiers;
            let attrs = vnode && vnode.data && vnode.data.attrs || {};

            if(!!stop || attrs.stop) {
                event.stopPropagation();
            }
        });
    }
};


// WEBPACK FOOTER //
// ./src/pages/native/pay/vip/link_vip_multiple/js/v-verify.js